/*
 * Description of what this file is for
 *
 * @package  craft3
 * @author Stefan Prosch [hello@stefanprosch.com]
 * schedule
 */

// import $ from 'jquery';

const schedule = {
    cfg:  {
        name: 'schedule',
        container: document.querySelector('.js-schedule'),
        filterMonth: document.querySelector('.js-selectMonth'),
        filterWeekday: document.querySelector('.js-selectWeek'),
        items: [...document.querySelectorAll('.js-scheduleItem')],
    },

    resetFilter() {
        //
    },

    initFilter() {
        // Add Event Listeners
        this.cfg.filterMonth.addEventListener('change', (event) => {
            this.setFilter(event);
        });
        this.cfg.filterWeekday.addEventListener('change', (event) => {
            this.setFilter(event);
        });

        Array.from(this.cfg.filterMonth.options).forEach((option_element) => {
            const option_value = Number(option_element.value);

            if (option_value === this.getCurrentMonth()) {
                this.cfg.filterMonth.value = this.getCurrentMonth();
            }
        });

        this.setFilter();
    },

    setFilter(event) {
        if (event) {
            event.preventDefault();
        }

        // eslint-disable-next-line
        console.log('setFilter --> Month: ' + this.getCurrentMonth());

        this.cfg.items.forEach((item) => {
            const trips = item.dataset.roundtrip.split(',');
            const day = this.cfg.filterWeekday.value;
            let isTrip = false;

            trips.forEach((val) => {
                if (val === this.cfg.filterMonth.options[this.cfg.filterMonth.selectedIndex].dataset[day]) {
                    isTrip = true;
                    // eslint-disable-next-line
                    console.log(val);
                }
            });

            if (isTrip) {
                item.classList.add('is-selected');
            } else {
                item.classList.remove('is-selected');
            }
        });
    },

    getCurrentMonth() {
        const today = new Date();
        const month = today.getMonth() + 1;
        return month;
    },

    init() {
        window.addEventListener('load', () => {
            if (this.cfg.container) {
                // this.resetFilter();
                this.initFilter();
            }
        });
    }
};

export default schedule;



// WEBPACK FOOTER //
// ./___src/templates/_molecules/schedule/_script.js